module.exports = __webpack_public_path__ + "static/media/pdf.06304cea.svg";